import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import GbIcon from './gb';
import DkIcon from './dk';
import DeIcon from './de';

const ButtonIcon = ({ language }) => {
  switch (language) {
    case 'da': return <DkIcon />
    case 'en': return <GbIcon />
    case 'de': return <DeIcon />
    default: return <GbIcon />
  }
}

const LanguageSelector = ({ }) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  }

  return (
    <div>
      <Button
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        style={{ backgroundColor: 'transparent', color: 'white' }}
      >
        <ButtonIcon language={i18n.language} />
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={(event) => handleLanguageChange('en', event)} disableRipple>
          <GbIcon />
        </MenuItem>
        <MenuItem onClick={(event) => handleLanguageChange('da', event)} disableRipple>
          <DkIcon />
        </MenuItem>
        <MenuItem onClick={(event) => handleLanguageChange('de', event)} disableRipple>
          <DeIcon />
        </MenuItem>
      </Menu>
    </div>
  );
};

export default LanguageSelector;
